import React, { useCallback, useContext, useEffect, useState } from "react";
import { withRouter, Redirect } from "react-router";
import app from "./../../firebase/firebase";
import { AuthContext, Reload } from "./Auth";
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"
import { Button, Form, Grid, Header, Image, Segment } from 'semantic-ui-react';
import axios from "axios";
import jsonwebtoken from "jsonwebtoken";

const Login = ({ history }) => {

    // const handleLogin = useCallback(
    //     async(event) => {
    //         event.preventDefault();
    //         const { email, senha } = event.target.elements;

    //         // const params = {
    //         //     "email": email,
    //         //     "password": senha
    //         // }

    //         // let config = {
    //         //     headers: {
    //         //         'Content-Type': 'application/json',
    //         //         'x-api-key': 'zDJnCq6byX9ku703Xdgfv88SCTJ8lZ5u645OCEM2'
    //         //     }
    //         // }

    //         // await axios.post('https://homolog.apisemparar.com.br/condominio-parceiros/v1/usuarios/login', params, config)
    //         // .then(res => {
    //         //     console.log('RES ', res)
    //         //     history.push()
    //         // })
    //         // .catch(error => {
    //         //     Toastify({
    //         //         text: 'ERROR AO FAZER LOGIN',
    //         //         duration: 3000,
    //         //         newWindow: true,
    //         //         close: true,
    //         //         gravity: "top",
    //         //         position: 'right',
    //         //         backgroundColor: "#e74c3c",
    //         //         stopOnFocus: false,
    //         //     }).showToast();
    //         // });

    //         // try {
    //         //     await app
    //         //     .auth()
    //         //     .signInWithEmailAndPassword(email.value, senha.value);
    //         //     history.push("/");
    //         // } catch (error) {
    //         //     Toastify({
    //         //         text: error.message,
    //         //         duration: 3000,
    //         //         newWindow: true,
    //         //         close: true,
    //         //         gravity: "top", // `top` or `bottom`
    //         //         position: 'right', // `left`, `center` or `right`
    //         //         backgroundColor: "#e74c3c",
    //         //         stopOnFocus: false, // Prevents dismissing of toast on hover
    //         //       }).showToast();
    //         // }
    //     }
    // );

    const handleLogin = async (e) => {
        e.preventDefault();

        const { email, senha } = e.target.elements;

        const params = {
            "email": email.value,
            "password": senha.value
        };

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': 'flA2resqZ43x2E1k5uYOBGjfCiMwtAV1v2vsTjtc'
            }
        }

        await axios.post(
            'https://prod.apisemparar.com.br/condominio-parceiros/v1/usuarios/login',
            params,
            config
        ).then(res => {

            const decoded = jsonwebtoken.verify(res.data.dados, 'parceiros-credenciados');
            console.log('RES ', res);
            console.log('DECODED ', decoded)
            sessionStorage.setItem("isAuth", "true");
            sessionStorage.setItem("storagedToken", JSON.stringify(decoded))

            history.push("/");
            Reload()
        }).catch(error => {
            var mensagem = 'Erro ao fazer login, contate o administrator para mais informações'
            if(error.request.response) {
                var m = JSON.parse(error.request.response);
                mensagem = m.status.mensagem;
            }

            Toastify({
                text: mensagem,
                duration: 3000,
                newWindow: true,
                close: true,
                gravity: "top",
                position: 'right',
                backgroundColor: "#e74c3c",
                stopOnFocus: false,
            }).showToast();
        });
    }

    const { currentUser } = useContext(AuthContext);
    const image = require('./../../assets/images/logo.png');

    if (currentUser) {
        return <Redirect to="/" />;
    }

    return (
        <Grid textAlign='center' style={{ height: '100vh', marginTop: '0px' }} verticalAlign='middle'>
            <Grid.Column style={{ maxWidth: 450, width: '90vw' }}>
                <Form onSubmit={handleLogin} size='large'>
                    <Segment stacked>
                        <Header as='h2' style={{color: '#d60b52'}} textAlign='center'>
                            <Image style={{width: '80%'}} src={image} />
                        </Header>

                        <Form.Input
                            fluid name="email"
                            id="loginEmail"
                            icon="mail"
                            iconPosition="left"
                            placeholder="Email"
                            type="text"
                                />

                        <Form.Input
                            fluid name="senha"
                            id="senha"
                            icon="key"
                            iconPosition="left"
                            placeholder="Senha"
                            type="password"
                            />

                        <Button

                            style={{color: '#fff',
                            backgroundColor: '#d60b52'}}
                            fluid
                            size='large'
                            >
                            Login
                        </Button>
                    </Segment>
                </Form>
            </Grid.Column>
        </Grid>
    );
};

export default withRouter(Login);